export default __webpack_public_path__ + "static/media/almax-mangisto.ad84ab87.png";